import { clampZoom, MIN_ZOOM } from './roi'

/**
 * Scanner settings that outlive a single scan.
 *
 * `ScannerView` unmounts every time a scan finishes, so anything it holds in
 * component state is gone by the next open. Zoom was being re-dialled by hand
 * on every single scan because of that, so it lives here instead.
 *
 * Failures are silent by design, exactly as in `lens.ts`: a private window or a
 * full quota must never stop the camera from opening.
 */

const ZOOM_KEY = 'scanflow.zoom'

export function loadZoom(): number {
  try {
    const raw = localStorage.getItem(ZOOM_KEY)
    if (raw === null) return MIN_ZOOM
    // clampZoom already folds NaN back to MIN_ZOOM, so a corrupt value needs no
    // separate check here.
    return clampZoom(Number(raw))
  } catch {
    /* corrupt or unavailable storage must not stop the camera opening */
    return MIN_ZOOM
  }
}

export function saveZoom(zoom: number): void {
  try {
    localStorage.setItem(ZOOM_KEY, String(clampZoom(zoom)))
  } catch {
    /* private mode / quota — the setting just won't persist */
  }
}
